var map = {
	"./select-lang-btn-ar.png": "da2d",
	"./select-lang-btn-de.png": "743a",
	"./select-lang-btn-en.png": "03f8",
	"./select-lang-btn-es.png": "2242",
	"./select-lang-btn-fr.png": "96c7",
	"./select-lang-btn-pt.png": "9f8c",
	"./select-lang-btn-ru.png": "1985",
	"./select-lang-btn-zh.png": "60a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e3ba";